<script setup lang="ts">
/***
 * Imports
 */
import type { PropType } from 'vue'
import type { FormKitFrameworkContext } from '@formkit/core'
import TipTap from './TipTap.vue'

import type { TLTipTapInput, TLTipTapValue } from '~/types/formkit-custom'

/***
 * Types
 */
type TContext = FormKitFrameworkContext<TLTipTapValue> & TLTipTapInput

/***
 * Props
 */
const props = defineProps({
  context: {
    type: Object as PropType<TContext>,
    default: null
  }
})

/***
 * Methods
 */
function handleInput(value?: string) {
  if (value === '<p></p>') {
    value = ''
  }
  props.context.node.input(value)
}
</script>

<template>
  <div id="formkit-tiptap-wrapper">
    <TipTap
      :editable="!props.context.attrs.disabled"
      :model-value="props.context._value"
      :bold="props.context.bold || true"
      :italic="props.context.italic || true"
      :underline="props.context.underline || true"
      :paragraph="props.context.paragraph || true"
      :h1="props.context.h1 || false"
      :h2="props.context.h2 || false"
      :h3="props.context.h3 || false"
      :h4="props.context.h4 || true"
      :h5="props.context.h5 || false"
      :h6="props.context.h6 || false"
      :bulletlist="props.context.bulletlist || true"
      :orderedlist="props.context.orderedlist || false"
      :codeblock="props.context.codeblock || false"
      :undo="props.context.undo || false"
      :redo="props.context.redo || false"
      @update:model-value="handleInput"
    />

    <div id="loading">
      <span> Loading text editor... </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#formkit-tiptap-wrapper {
  min-height: 200px;
  border: 1px solid var(--borderM2);
  border-radius: 7px;
  position: relative;

  #loading {
    position: absolute;
    top: 0;
    right: 0;
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.95rem;
    color: var(--textL2);
    z-index: -1;
  }
}
</style>
